import type { CourseModule } from "@/core/types";
import { lektionAufbau } from "./lektion-01-aufbau";
import { lektionLayoutWaehlen } from "./lektion-02-layout-waehlen";
import { lektionGliederung } from "./lektion-03-gliederung";
import { lektionFolienVerwalten } from "./lektion-04-folien-verwalten";

export const modulFolien: CourseModule = {
  id: "folien",
  title: "Folien und Layouts",
  summary:
    "Der Baukasten hinter jeder Präsentation: Design, Folienmaster, Layout, Folie – " +
    "und warum jede Folie ein Layout und einen Titel braucht.",
  level: "Grundlagen",
  lessons: [lektionAufbau, lektionLayoutWaehlen, lektionGliederung, lektionFolienVerwalten],
};
